<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/resetPassword.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">فرم فراموشی رمز عبور</h4>
                  <p>خوش آمدید...</p>
                </div>

                <div @keydown.enter="resetPassword()">
                  <vs-input
                    v-validate="'required|min:11|max:11'"
                    data-vv-validate-on="blur"
                    name="phone_number"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="شماره موبایل"
                    v-model="phone_number"
                    class="w-full"/>
                  <span class="text-danger text-sm">{{ errors.first('phone_number') }}</span>
                  <div class="my-4">
                    <vs-button  type="border" to="/pages/login">ورود</vs-button>
                    <vs-button class="float-right" :disabled="!validateForm" @click="resetPassword()">بازیابی رمز عبور</vs-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    phone_number: {
      required: 'وارد کردن شماره موبایل الزامی است.*',
      min: "شماره موبایل نمی تواند کمتر از 11 رقم باشد.",
      max: "شماره موبایل نمی تواند بیشتر از 11 رقم باشد."
    },
  }
};

// register custom messages
Validator.localize('en', dict);

export default{
  data() {
    return {
        phone_number: "",
    }
  },

  computed: {
    validateForm() {
      return this.phone_number != '';
    },
  },

  created() {
    this.$vs.loading.close()
  },

  methods: {
    resetPassword() {
      this.$vs.loading()
      const payload = {
        phone_number: this.phone_number
      }
      this.$store.dispatch('resetPassword', payload).then(() => {
        this.$vs.loading.close()
        this.$router.push({name: 'page-login'}).catch(() => {})
      }).catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
              title: '',
              text: 'طلاعات ارسالی صحیح نمی باشد.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
          })
      })
    }
  }
}
</script>

<style>

</style>
